import DeleteContract from "./DeleteContract";
export default DeleteContract;
